import React, { useState, useEffect } from "react";
import { GoogleApiWrapper } from "google-maps-react";
import { GoogleMap, DirectionsRenderer, Marker } from "@react-google-maps/api";
import styles from "./DashBoard.module.scss";
import { GOOGLE_API_KEY } from "../../services/AppSettingsService";
import {
  expandMapIcon,
  collapseMapIcon,
  pickupTimelineIcon,
  dropoffTimelineIcon,
} from "../../assets/images";
import { ITripCardDetails, ITripDetails } from "../ServiceUsers/Interfaces/ITripDetails";
import { IDownloadPdfTrip } from "../../types/DownloadPdfTypes";

type Props = {
  tripDetails: ITripDetails | IDownloadPdfTrip | ITripCardDetails;
  width?: string;
  height?: string;
  google: any;
  loaded: boolean;
  isMapModalOpen?: boolean;
  setIsMapModalOpen?: Function;
  hideExpandIcon?: boolean;
  isCalling?: string;
};
const DashBoardGmaps: React.FC<Props> = ({
  tripDetails,
  width,
  height,
  google,
  isMapModalOpen,
  setIsMapModalOpen,
  loaded,
  isCalling,
  hideExpandIcon,
}) => {
  const drop = {
    address: tripDetails?.pickUpAddress1,
    city: tripDetails?.pickUpCity,
    state: tripDetails?.pickUpState,
    zip: tripDetails?.pickUpZipCode,
  };
  const pickup = {
    address: tripDetails?.dropOffAddress1,
    city: tripDetails?.dropOffCity,
    state: tripDetails?.dropOffState,
    zip: tripDetails?.dropOffZipCode,
  };

  const [
    directions,
    setDirections,
  ] = useState<google.maps.DirectionsResult | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [pickupLatLng, setPickupLatLng] = useState<any>("");
  const [dropLatLng, setDropLatLng] = useState<any>("");

  const mapOptions: google.maps.MapOptions = {
    disableDefaultUI: true,
    mapTypeControl: false,
    fullscreenControl: false,
    zoomControl: false,
    keyboardShortcuts: false,
  };

  useEffect(() => {
    if (tripDetails) {
      const directionsService = new google.maps.DirectionsService();
      const geocoder = new google.maps.Geocoder();
      const request = {
        origin: `${drop.address}, ${drop.city}, ${drop.state} ${drop.zip}`,
        destination: `${pickup.address}, ${pickup.city}, ${drop.state} ${pickup.zip}`,
        travelMode: google.maps.TravelMode.DRIVING,
      };
      directionsService.route(request, (result: any, status: any) => {
        if (status === google.maps.DirectionsStatus.OK) {
          setDirections(result);
          setError(null);
          geocoder.geocode({ address: request.origin }, function(
            results: {
              geometry: { location: React.SetStateAction<undefined> };
            }[],
            status: string
          ) {
            if (status == "OK") {
              setPickupLatLng(results[0].geometry.location);
            }
          });

          geocoder.geocode({ address: request.destination }, function(
            results: {
              geometry: { location: React.SetStateAction<undefined> };
            }[],
            status: string
          ) {
            if (status == "OK") {
              setDropLatLng(results[0].geometry.location);
            }
          });
        } else {
          setError(status);
        }
      });
    }
  }, [tripDetails]);

  const showModal = () =>
    setIsMapModalOpen && setIsMapModalOpen(!isMapModalOpen);

  return (
    <div className={"container " + styles.mapContainer}>
      <GoogleMap
        mapContainerStyle={{ width: width, height: height }}
        zoom={7}
        options={mapOptions}
      >
        {directions && (
          <DirectionsRenderer
            directions={directions}
            options={{
              suppressMarkers: true,
              polylineOptions: {
                strokeColor: "#1F83D0",
                strokeWeight: 6,
                strokeOpacity: 1,
              },
            }}
          />
        )}
        {pickupLatLng && (
          <Marker
            position={pickupLatLng}
            icon={pickupTimelineIcon}
            opacity={1}
          />
        )}
        {dropLatLng && (
          <Marker
            position={dropLatLng}
            icon={dropoffTimelineIcon}
            opacity={1}
          />
        )}
      </GoogleMap>
      {!hideExpandIcon && (
        <div className={styles.expandIconWrapper}>
          {isMapModalOpen ? (
            <img
              src={collapseMapIcon}
              className={
                isCalling === "mobile"
                  ? styles.collapseMobileImg
                  : styles.collapseImg
              }
              onClick={showModal}
            />
          ) : (
            <img
              src={expandMapIcon}
              className={
                isCalling === "mobile"
                  ? styles.expandMobileImg
                  : styles.expandImg
              }
              onClick={showModal}
            />
          )}
        </div>
      )}
    </div>
  );
};

export default GoogleApiWrapper({
  apiKey: GOOGLE_API_KEY(),
})(DashBoardGmaps);
